module.exports = __webpack_public_path__ + "static/img/GettyImages-530293155.91a1509.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/GettyImages-530293155.jpg
// module id = OM51
// module chunks = 0